export default {
    BACKEND_URL: "https://api.synup.com",
    FRONTEND_URL: "https://dev.synup.com",
}